/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserCountResponse } from '../../models/user-count-response';

export interface UserControllerCount$Params {
  roles?: Array<string>;
  email?: string;
  firstName?: string;
  lastName?: string;
  gender?: string;
  fiscalCode?: string;
  city?: string;
  province?: string;
  region?: string;
  mobilePhone?: string;
  altMobilePhone?: string;
  field?: 'id' | 'username' | 'firstName' | 'lastName' | 'email' | 'gender' | 'notes' | 'fiscalCode' | 'dateOfBirth' | 'city' | 'province' | 'zipCode' | 'address' | 'mobilePhone' | 'altMobilePhone' | 'createdOn' | 'updatedOn';
  direction?: 'asc' | 'desc';
  companyId?: number;
  query?: string;
  limit?: number;
  skip?: number;
}

export function userControllerCount(http: HttpClient, rootUrl: string, params?: UserControllerCount$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserCountResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, userControllerCount.PATH, 'get');
  if (params) {
    rb.query('roles', params.roles, {});
    rb.query('email', params.email, {});
    rb.query('firstName', params.firstName, {});
    rb.query('lastName', params.lastName, {});
    rb.query('gender', params.gender, {});
    rb.query('fiscalCode', params.fiscalCode, {});
    rb.query('city', params.city, {});
    rb.query('province', params.province, {});
    rb.query('region', params.region, {});
    rb.query('mobilePhone', params.mobilePhone, {});
    rb.query('altMobilePhone', params.altMobilePhone, {});
    rb.query('field', params.field, {});
    rb.query('direction', params.direction, {});
    rb.query('companyId', params.companyId, {});
    rb.query('query', params.query, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserCountResponse;
      }>;
    })
  );
}

userControllerCount.PATH = '/user/count';
